import { orderBy } from 'lodash';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'tableSorter' })
export class TableSorter implements PipeTransform {
  transform(list: any[], columns: any, sort: { key: string; direction: 'asc' | 'desc' }) {
    const columnIndexHash = columns.reduce((hash: { [key: string]: number }, { key }, index: number) => {
      hash[key] = index;
      return hash;
    }, {});

    const sortIndex = columnIndexHash[sort.key];
    return orderBy(list, o => o[sortIndex].data, [sort.direction]);
  }
}
